module.exports = __webpack_public_path__ + "static/img_9931_dpp_optimized-b35d6985176dcd27c27578e03bdf752d.jpg";